import axios, { AxiosInstance } from "axios";
import { v4 as uuidv4 } from "uuid";

export const basePath = "https://api.cloudinary.com/v1_1";

// The paths for all the Cloudinary endpoints.
export const cloudinaryApiPath = {
  uploadImage: (cloudName: string) => `${basePath}/${cloudName}/image/upload`,
};

/**
 * Generate a unique identifer for the image when uploaded to Cloudinary.
 *  - The folder name is the folder the image would be stored in.
 *  - The UUID is the name of the file.
 *  - Currently following what old dreambig does (the folder name + uuid with dashes stripped)
 */
const generatePublicId = (folderName: string) => {
  return `${folderName}/${uuidv4().replace(/-/g, "")}`;
};

export const CloudinaryHelper = {
  generatePublicId,
};

/**
 * Class to make calls to the Cloudinary API.
 *  - api: Axios instance.
 *  - cloudName: The name of the Cloudinary instance.
 *  - apiKey: The apiKey for the Cloudinary instance.
 */
// TODO: Move this into the external folder
class CloudinaryApi {
  api: AxiosInstance;
  cloudName: string;
  apiKey: string;

  constructor(cloudName: string, apiKey: string) {
    this.api = axios.create({
      baseURL: basePath,
    });

    this.cloudName = cloudName;
    this.apiKey = apiKey;
  }

  /**
   *
   * POST https://api.cloudinary.com/v1_1/<cloudName>/image/upload
   *
   * Purpose:
   *  - Upload an image to cloudinary
   *
   * Reference: https://cloudinary.com/documentation/image_upload_api_reference#upload
   */
  uploadImage = (imageData: FormData) => {
    return this.api.post(
      cloudinaryApiPath.uploadImage(this.cloudName),
      imageData,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
  };
}

export default CloudinaryApi;
